import React from 'react';

import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

export const Check = (): string => {
  const classes = useStyles();
  return classes.check;
};

export const CheckIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.check} {...props} />;
};
